import React from 'react'

function ManageCompanyLayer() {
  return (
    <div>

    </div>
  )
}

export default ManageCompanyLayer
